import { getProfile } from '../../store/auth'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

const GoldSiverHeader = ({previous,title,children,showWrapper = true}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const user_data = useSelector(state=>state.auth.user_data)
    const location = useLocation()
    
    // מעקב אחרי ניסיונות יציאה מקרב
    const [exitAttempts, setExitAttempts] = useState(0);

    const getProfileData = async () => {
        try {
            await dispatch(getProfile()).unwrap();
        } catch (error) {
            console.error("Error loading profile data:", error);
        }
    }
    
    useEffect(()=>{
        getProfileData()
    },[])
    
    const handleBackButtonClick = () => {
        // בדיקה אם אנחנו בדף קרב
        if (location.pathname === '/battle') {
            console.log("Back button clicked while in battle");
            
            try {
                // בדיקה אם יש קרב פעיל ב-localStorage
                const activeBattleData = localStorage.getItem('activeBattle');
                
                if (activeBattleData) {
                    try {
                        const battleState = JSON.parse(activeBattleData);
                        
                        // בדיקה אם הקרב הסתיים או לא
                        if (!battleState.winLose) {
                            console.log("Active battle detected - preventing navigation");
                            
                            // הגדלת מונה ניסיונות היציאה
                            setExitAttempts(prev => prev + 1);
                            
                            // אם יש יותר מדי ניסיונות לצאת, נאפשר יציאת חירום
                            if (exitAttempts >= 3) {
                                toast.warning("יציאת חירום מהקרב...");
                                localStorage.removeItem('activeBattle');
                                localStorage.removeItem('battleInitTime');
                                
                                // נשתמש בהשהייה קצרה לפני הניווט
                                setTimeout(() => {
                                    navigate(previous);
                                }, 100);
                                
                                return;
                            }
                            
                            // הודעה רגילה למניעת יציאה
                            toast.warning("לא ניתן לצאת מקרב פעיל! עליך לנצח או להפסיד כדי לצאת.");
                            return; // מניעת ניווט
                        }
                    } catch (error) {
                        console.error("Error parsing battle state data:", error);
                        // אם יש שגיאה בניתוח ה-JSON, נמחק את הנתונים כדי לאפשר יציאה
                        localStorage.removeItem('activeBattle');
                    }
                }
                
                // בדיקה נוספת - האם הקרב החל זה עתה
                const lastBattleInitTime = localStorage.getItem('battleInitTime');
                if (lastBattleInitTime) {
                    try {
                        const initTime = parseInt(lastBattleInitTime);
                        const currentTime = Date.now();
                        
                        // אם עברו פחות מ-3 שניות מאז אתחול הקרב, זה כנראה קרב חדש
                        if (currentTime - initTime < 3000) {
                            console.log("Battle just started - preventing navigation");
                            toast.warning("הקרב התחיל זה עתה! אנא המתן רגע לפני שתנסה לצאת.");
                            return; // מניעת ניווט
                        }
                    } catch (error) {
                        console.error("Error parsing battle init time:", error);
                        localStorage.removeItem('battleInitTime');
                    }
                }
            } catch (error) {
                console.error("Error checking battle state:", error);
                // במקרה של שגיאה, נאפשר יציאה כדי למנוע תקיעה
                localStorage.removeItem('activeBattle');
                localStorage.removeItem('battleInitTime');
            }
        } else {
            // איפוס מונה ניסיונות היציאה כשלא בקרב
            setExitAttempts(0);
        }
        
        // נשתמש בהשהייה קצרה לפני הניווט
        setTimeout(() => {
            navigate(previous);
        }, 50);
    };
    
    return (
        <div className='pb-2'>
            {showWrapper ? (
                <section className="ar_main_content_area_wrapper p-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ar_main_container_area">
                                    <div className="ar_heading_area_top">
                                        <div className="ar_heading_title_back">
                                            <a className="ar_back cursor-pointer" onClick={handleBackButtonClick}><img src="/images/game-ui/reButton.png" alt="images" /></a>
                                            <h3> {title} </h3>
                                            <a href="#"><img src="/images/game-ui/question.png" alt="images" /></a>
                                        </div>
                                        <div className="ar_heading_title_plus">
                                            <div className="arTitle_plus_area">
                                                <div className="arTitle_plus_img " >
                                                    <img src="/images/game-ui/p1.png" alt="" className='cursor-pointer' onClick={()=>navigate('/packages?buy=golds')} />
                                                    <p>{user_data?.gold}</p>
                                                </div>
                                                <div className="arTitle_plus_img " >
                                                    <img src="/images/game-ui/p2.png" alt="" className='cursor-pointer' onClick={()=>navigate('/packages?buy=silvers')}/>
                                                    <p className="one152">{user_data?.silver}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <div className="ar_main_container_area">
                    <div className="ar_heading_area_top">
                        <div className="ar_heading_title_back">
                            <a className="ar_back cursor-pointer" onClick={handleBackButtonClick}><img src="/images/game-ui/reButton.png" alt="images" /></a>
                            <h3> {title} </h3>
                            <a href="#"><img src="/images/game-ui/question.png" alt="images" /></a>
                        </div>
                        <div className="ar_heading_title_plus">
                            <div className="arTitle_plus_area">
                                <div className="arTitle_plus_img " >
                                    <img src="/images/game-ui/p1.png" alt="" className='cursor-pointer' onClick={()=>navigate('/packages?buy=golds')} />
                                    <p>{user_data?.gold}</p>
                                </div>
                                <div className="arTitle_plus_img " >
                                    <img src="/images/game-ui/p2.png" alt="" className='cursor-pointer' onClick={()=>navigate('/packages?buy=silvers')}/>
                                    <p className="one152">{user_data?.silver}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {children}
        </div>
    )
}

export default GoldSiverHeader
